module.exports = __webpack_public_path__ + "media/newstyle/images/alphagraphics-10b04dd05550c4acd610cea43278903b.svg";